import React from "react";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import Button from "components/Button";
import COLORS from "shared/constants/colors";
import {
  DesignPanel,
  DesignPanelTitle,
  DesignThumbGrid,
  DesignThumb,
  DropZone,
  DropZoneTitle,
  DropZoneSubtitle,
  HelpText,
  DesignThumbContainer,
  DesignMetaText,
} from "styles/pages/dtf-transfers/gang-sheet";

const DesignLibraryPanel = ({
  designs,
  isDragging,
  onBrowse,
  onDropFiles,
  onDragState,
  onAddDesign,
}) => (
  <DesignPanel>
    <DesignPanelTitle>Designs</DesignPanelTitle>
    <DropZone
      $isDragging={isDragging}
      onDragOver={(event) => {
        event.preventDefault();
        onDragState(true);
      }}
      onDragLeave={() => onDragState(false)}
      onDrop={(event) => {
        event.preventDefault();
        onDragState(false);
        onDropFiles(event.dataTransfer.files);
      }}
      onClick={onBrowse}
    >
      <CloudUploadOutlinedIcon style={{ color: COLORS.BLUE, fontSize: 28 }} />
      <DropZoneTitle>Upload designs</DropZoneTitle>
      <DropZoneSubtitle>PNG, JPG, SVG — click or drop</DropZoneSubtitle>
    </DropZone>
    <HelpText>Click a thumbnail to place it on the sheet.</HelpText>
    <div style={{ marginTop: 10 }}>
      <Button
        title="Browse files"
        onClick={(event) => {
          event.stopPropagation();
          onBrowse();
        }}
        containerStyle={{
          background: COLORS.BLUE,
          color: COLORS.WHITE,
          textTransform: "none",
          borderRadius: "6px",
          width: "100%",
        }}
      />
    </div>
    {designs.length ? (
      <DesignThumbGrid style={{ marginTop: 12 }}>
        {designs.map((design) => {
          const wIn =
            design.widthIn || (design.width ? design.width / 300 : null);
          const hIn =
            design.heightIn || (design.height ? design.height / 300 : null);
          const sizeLabel =
            wIn && hIn
              ? `${Number(wIn).toFixed(1)}" × ${Number(hIn).toFixed(1)}"`
              : "";

          return (
            <DesignThumbContainer
              key={design.id || design.publicId || design.secureUrl}
            >
              <DesignThumb
                type="button"
                title={design.fileName}
                onClick={() => onAddDesign(design)}
              >
                <img
                  src={design.previewUrl || design.secureUrl}
                  alt={design.fileName}
                />
              </DesignThumb>
              <DesignMetaText>
                <div className="name" title={design.fileName}>
                  {design.fileName}
                </div>
                {sizeLabel && <div className="dims">{sizeLabel}</div>}
              </DesignMetaText>
            </DesignThumbContainer>
          );
        })}
      </DesignThumbGrid>
    ) : null}
  </DesignPanel>
);

export default DesignLibraryPanel;
